// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1mpCr","infoBtn":"quickbooks_infoBtn__GiOI8","formBox":"quickbooks_formBox__1HNDH","formFooter":"quickbooks_formFooter__3NUBJ"};